/*
 *
 * Communications reducer
 *
 */
import produce from "immer";

import {
  FLUSH_STATE_COMMUNICATIONS,
  // load items list
  LOAD_COMMUNICATIONS,
  LOAD_COMMUNICATIONS_SUCCESS,
  LOAD_COMMUNICATIONS_ERROR,
} from "./constants";

export const initialState = {
  firstRender: true,
  loading: false,
  error: false,
  itemsList: [],
  allData: false,
  pages: 1,
  currentPage: 1,
  totalAmount: 0,
  // filter list
  childId: "",
  params: {
    page: 1,
    limit: 8,
    searchStr: "",
    filterValue: [],
  },
  filtering: false,
  noMore: false,
};

/* eslint-disable default-case, no-param-reassign */
const communicationsMobileReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_COMMUNICATIONS:
        return initialState;

      // LOAD
      case LOAD_COMMUNICATIONS:
        draft.firstRender = action.firstRender;
        draft.loading = true;
        draft.error = false;
        draft.childId = action.childId;
        if (
          !state?.firstRender &&
          (state?.params?.searchStr != action?.params?.searchStr ||
            JSON.stringify(state?.params?.filterValue) !=
              JSON.stringify(action?.params?.filterValue))
        ) {
          draft.filtering = true;
          draft.params = {
            ...action.params,
            page: 1,
          };
          draft.noMore = false;
        } else {
          draft.filtering = false;
          draft.params = action.params;
        }
        break;
      case LOAD_COMMUNICATIONS_SUCCESS:
        draft.allData = action.allData;
        draft.totalAmount = action.allData?.totalAmount || 0;
        draft.pages = action.allData?.pages || 1;
        draft.currentPage = action.allData?.currentPage || 1;
        draft.itemsList = action.itemsList;
        draft.loading = false;

        // set No More action
        if (action.allData?.currentPage == action.allData?.pages) {
          draft.noMore = true;
        }

        break;
      case LOAD_COMMUNICATIONS_ERROR:
        draft.error = action.error;
        draft.loading = false;
        draft.firstRender = false;
        draft.noMore = false;
        draft.filtering = false;
        break;
    }
  });

export default communicationsMobileReducer;
